import { ReactNode } from "react";

import { Icon } from "@/atoms/icon/Icon";

type IconType = Parameters<typeof Icon>[0]["svg"];

export interface OnboardingHeaderV3Props {
  icon?: IconType;
  title: string | ReactNode;
  subtitle?: string | ReactNode;
  align?: "left" | "center";
  className?: string;
}

export const OnboardingHeaderV3 = ({
  icon,
  title,
  subtitle,
  align = "center",
  className = "",
}: OnboardingHeaderV3Props) => {
  const alignment = align === "center" ? "items-center text-center" : "items-start text-left";

  return (
    <div
      className={`flex w-full flex-col gap-4 pt-4 font-normal leading-[0] ${alignment} ${className}`}
    >
      {icon ? <Icon svg={icon} color="brandColor" size="xlarge" /> : null}
      <div className="font-serif text-[24px] italic text-[#091f24]">
        {typeof title === "string" ? <p className="leading-[32px]">{title}</p> : title}
      </div>
      {subtitle ? (
        <div
          className="font-sans text-[14px] font-normal leading-[18px] text-[#6b7070]"
          style={{ fontVariationSettings: "'opsz' 14" }}
        >
          {typeof subtitle === "string" ? <p className="leading-[18px]">{subtitle}</p> : subtitle}
        </div>
      ) : null}
    </div>
  );
};

export default OnboardingHeaderV3;
